export const ACCOUNT = "ACCOUNT"
export const ADMIN = "ADMIN"
export const BOTS = "BOTS"
export const DEV_TOOLS = "DEV_TOOLS"
export const HOME = "HOME"
export const INTERNAL = "INTERNAL"
export const MEDICAL = "MEDICAL"
export const ONLINEGP = "ONLINEGP"
export const EAP = "EAP"
export const SAVINGS = "SAVINGS"
export const ONBOARDING = "ONBOARDING"
export const PERKS = "PERKS"
export const FLEXIREWARDS = "FLEXIREWARDS"
export const PLATFORM = "PLATFORM"
export const PUBLIC = "PUBLIC"
export const RECOGNITION = "RECOGNITION"
export const REWARD = "REWARD"
export const SEARCH = "SEARCH"
export const WALLET = "WALLET"
export const WELLNESS = "WELLNESS"
export const WELCOME = "WELCOME"
export const CULTUREHUB = "CULTUREHUB"
export const BENEFITS = "BENEFITS"
export const CYCLETOWORK = "CYCLETOWORK"
export const HOMEANDELECTRONICS = "HOMEANDELECTRONICS"
export const BIKESHOP = "BIKESHOP"
export const ANNUALLEAVEPURCHASE = "ANNUALLEAVEPURCHASE"
export const PAYROLLGIVING = "PAYROLLGIVING"
export const SALARYFINANCE = "SALARYFINANCE"
export const HEALTHCASHPLAN = "HEALTHCASHPLAN"
export const GYMMEMBERSHIP = "GYMMEMBERSHIP"
export const PENSIONADVANTAGE = "PENSIONADVANTAGE"
export const TRAVELANDLEISURE = "TRAVELANDLEISURE"
export const CARBENEFIT = "CARBENEFIT"
export const ORDERHISTORY = "ORDERHISTORY"
export const LOCALBENEFITS = "LOCALBENEFITS"
export const ORDERMANAGEMENT = "ORDERMANAGEMENT"
export const ADVANCEDBUDGET = "ADVANCEDBUDGETS"
export default {
  [ACCOUNT]: "/account",
  [ADMIN]: "/admin",
  [BOTS]: "/bots",
  [DEV_TOOLS]: "/dev-tools",
  [HOME]: "/home",
  [INTERNAL]: "/internal",
  [MEDICAL]: "/medical",
  [ONLINEGP]: "/online-gp",
  [EAP]: "/eap",
  [SAVINGS]: "/my-savings",
  [ONBOARDING]: "/onboard",
  [PERKS]: "/perks",
  [FLEXIREWARDS]: "/rewards",
  [PLATFORM]: "/",
  [PUBLIC]: "/public",
  [RECOGNITION]: "/recognition",
  [SEARCH]: "/search",
  [WALLET]: "/wallet",
  [WELLNESS]: "/wellness",
  [WELCOME]: "/welcome",
  [CULTUREHUB]: "/culture-hub",
  [BENEFITS]: "/benefits",
  [CYCLETOWORK]: "/cycle-to-work",
  [HOMEANDELECTRONICS]: "/home-and-electronics",
  [BIKESHOP]: "/bike-shop",
  [ANNUALLEAVEPURCHASE]: "/annual-leave-purchase",
  [CARBENEFIT]: "/car-benefit",
  [PAYROLLGIVING]: "/payroll-giving",
  [SALARYFINANCE]: "/salary-finance",
  [HEALTHCASHPLAN]: "/healthcare-cash-plan",
  [GYMMEMBERSHIP]: "/gym-benefit",
  [PENSIONADVANTAGE]: "/pension-top-up",
  [TRAVELANDLEISURE]: "/travel-benefit",
  [ORDERHISTORY]: "/order-history",
  [LOCALBENEFITS]: "/company-benefits",
  [ORDERMANAGEMENT]: "/orders"
}
